import * as React from 'react';
import { MssPublishButton } from '../shared/mss-publish-button';
import { MssPublishAllDialog } from './mss-publish-all-dialog';
import { getPlayers, mapPlayersToPublish } from './lib/actions';
import { PlayerPublish } from './lib/types';

export default function MssPublishWidget() {
  const [publishOpen, setPublishOpen] = React.useState(false);
  const [players, setPlayers] = React.useState<PlayerPublish[]>([]);

  const showPublishDialog = async () => {
    const data = await getPlayers();
    setPlayers(mapPlayersToPublish(data));
    setPublishOpen(true);
  };

  return (
    <>
      <MssPublishButton onClick={showPublishDialog} />
      <MssPublishAllDialog
        open={publishOpen}
        onOpenChange={setPublishOpen}
        players={players}
      />
    </>
  );
}
